import PropTypes from 'prop-types';
import React from 'react';

import {ButtonAdd} from '@appComponents/ButtonCollection';
import {THIRD_PARTY_CLIENT_TUNNEL} from '@constants/resources';
import {SECURITY_PRIVILEGES_CREATE} from '@constants/variables';
import Link from '@appComponents/Link';
import Authorization from '@appComponents/Authorization';

const ThirdPartyTunnelsIndexButtons = (props) => (
    <div className='content__buttons'>
        <Authorization
            privileges={SECURITY_PRIVILEGES_CREATE}
            resources={THIRD_PARTY_CLIENT_TUNNEL}
        >
            <Link
                name={'clients.products.thirdParty.tunnels.add'}
                params={{id: props.clientId}}
            >
                <ButtonAdd>{'Add new tunnel'}</ButtonAdd>
            </Link>
        </Authorization>
    </div>
);

ThirdPartyTunnelsIndexButtons.propTypes = {
    clientId: PropTypes.number.isRequired,
};

export default ThirdPartyTunnelsIndexButtons;
